/* istanbul ignore file */

import styled from 'styled-components'

export const ChartContainer = styled.div`
  width: 100%;
  height: 210px;
  position: relative;
  top: 30px;
`

export const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
